import { useState } from 'react'
import UserOrderDetailHook from './hooks'
import {
  InfoCircleFilled,
  DeleteOutlined,
  EditOutlined,
  CheckOutlined,
  LoadingOutlined,
  DownloadOutlined,
  UploadOutlined,
  QuestionCircleFilled,
  WarningOutlined,
} from '@ant-design/icons'
import styles from './style.module.scss'
import {
  Button,
  Col,
  Row,
  Space,
  Tooltip,
  Spin,
  Tabs,
  Steps,
  Tag,
  Modal,
} from 'antd'
import { Link } from 'react-router-dom'
import CustomTable from '../../components/CustomTable'
import { UploadCertificateModal } from '../../modules/orderdetail/uploadCertificateModal'
import { certificateTypeDict } from '../../api/orderManage'
import moment from 'moment'
import { GetLocalStorage, timeFormatStr } from '../../tools/util'
import Tippy from '@tippyjs/react'
import { QuestionCircleOutlined, CloseCircleOutlined } from '@ant-design/icons'
import {
  accountOpenInvoiceStateDictInvert,
  openInvoiceStateDictInvert,
  paymentStatusDict,
  paymentStatusDictInvert,
  returnStateEnum,
} from '../../tools/state'
import { handleJumpAddPayment } from '../payable-orders/hooks'
import PreviewModal, {
  DefaultWaterMarkOption,
} from '../../components/previewModal'
import ThumbnailPreview from '../../components/ThumbnailPreview'
import { orderdetailTabKey, orderdetailTabKeyList } from './reducer'
import Customupload from '@/components/UploadFile'
import CustomIcon from '@/components/IconUser'
import BraftEditor from '../../components/BraftEditer'
import { fileFile } from '@/modules/goodsdetailmodules/uploadfiles'
import OverdueFeedbackModal from './components/OverdueFeedbackModal'
import xlsx from '../../assets/img/EXCEL.png'
import img from '../../assets/img/IMG.png'
import pdf from '../../assets/img/PDF.png'
import docx from '../../assets/img/WORD.png'
const { Step } = Steps

import { Form, Input } from 'antd'
import { defaultRender } from '@/tools/table'
import { redInvoiceStateEnum, shifouEnum } from '@/global/enum'
import { useTypedSelector } from '@/redux/store'
import {
  getDictList,
  getDictLabel,
  getDictOptions,
  getDictValue,
} from '@/modules/dict'
export const orderNoRender = (text: any, record: any, index: number) => {
  return index + 1 + ''
}
// 发货进度判断
export const stateColorDict: any = {
  已签收: 'green',
  待收货: 'lightblue',
}
export const returnStateColorDict: any = {
  已退货: 'green',
  退货中: 'lightblue',
  默认: 'black',
}
export function useThumbnailRenderHook() {
  const thumbnailRender = (text: any) => {
    return text ? <ThumbnailPreview src={text}></ThumbnailPreview> : ''
  }
  return { thumbnailRender }
}

export const orderStateDict = {
  待履约: {
    tagColor: 'orange',
    desp: '请核对订单并发货',
  },
  履约中: {
    tagColor: 'orange',
    desp: '请将所有物料全部发货',
  },
  待验收: {
    tagColor: 'orange',
    desp: '上传签收凭证，并等待咸亨确认',
  },
  撤回: {
    tagColor: 'default',
    desp: '已撤回，无需履约',
  },
  已取消: {
    tagColor: 'default',
    desp: '已取消，无需履约',
  },
  已完成: {
    tagColor: 'success',
    desp: '客户回款后可对账',
  },
}
export type stateKey = keyof typeof orderStateDict

export const renderStateInfo = (orderState: stateKey) => {
  const isValidState = Object.keys(orderStateDict).includes(orderState)
  if (isValidState) {
    const info = orderStateDict?.[orderState as stateKey]
    return (
      <Space>
        <Tag color={info.tagColor}>{orderState}</Tag>
        <span className={styles['desp-info']}>{info?.desp}</span>
      </Space>
    )
  } else {
    return <Tag>{orderState}</Tag>
  }
}

export default function OrderDetail() {
  const [overdueFeedbackOpen, setOverdueFeedbackOpen] = useState(false)
  const {
    baseUrl,
    hookstate,
    progressList,
    getCurrentProgress,
    handleJumpInvoice,
    handleDeliveryClick,
    handleOrderTransferClick,
    handleTableChangeCheck,
    showUploadCertificateModal,
    cancelUploadCertificateModal,
    handleDelCertificate,
    handleEditCertificate,
    handleSubmitEnd,
    downloadAllCertificate,
    downloadCustomCertificate,
    showPreviewModal,
    cancelPreviewModal,
    saveAndSubmitCheck,
    getAddOrderAccept,
    downLoadTemplate,
    inTableUploadfile,
    onClickDown,
    showTemplateModal,
    onClickDel,
    openModal,
    handleContentChange,
    submitRichText,
    uploadRichfile,
    onClickDelDes,
    richTextRef,
    refreshData,
  } = UserOrderDetailHook()
  const {
    detailInfo,
    isTableLoading,
    productList,
    loading,
    isPreviewModalVisible,
    previewFileUrl,
    uploadCertificateModalOption,
    currentEditCertificate,
    invoiceInfo,
    waterMarkOption,
    detailListData,
    isOpenModal,
    richText,
    orderDescriptionFiles,
  } = hookstate

  // 获取字典数据
  const dictData = useTypedSelector((state) => state.dictData.dictData)

  console.log(dictData, 'dictData')

  // 使用字典的示例：
  // 1. 获取字典列表
  // const statusList = getDictList('status', dictData)

  // 2. 根据值获取标签
  // const statusLabel = getDictLabel('status', '1', dictData)

  // 3. 获取 Select 选项
  // const statusOptions = getDictOptions('status', dictData)

  // 4. 根据标签获取值
  // const statusValue = getDictValue('status', '启用', dictData)

  const orderProgressRender = (text: any) => {
    const progressObj: any = {
      '1': { text: '未发', color: 'red' },
      '2': { text: '部分', color: 'black' },
      '3': { text: '完成', color: 'green' },
    }
    return (
      <span style={{ color: progressObj[text]?.color }}>
        {progressObj[text]?.text}
      </span>
    )
  }

  const thumbnailRender = (text: any) =>
    text === 'loading' ? (
      <LoadingOutlined />
    ) : (
      <img
        src={
          text || `${GetLocalStorage('BASEURL')}ui-common-imgs/default_pic.svg`
        }
        alt=""
        style={{
          width: '20px',
          height: '20px',
          objectFit: 'contain',
          cursor: 'pointer',
        }}
        onClick={() => text && showPreviewModal(text, DefaultWaterMarkOption)}
      />
    )

  const filesRender = () => {
    const purchaseOrderContract = detailInfo?.purchaseOrderContract
    return (
      <Col>
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <CustomIcon type="icon-wenjian1" style={{ fontSize: '20px' }} />
          <span
            className={styles['file-name']}
            style={{
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
              maxWidth: '120px',
              overflow: 'hidden',
              display: 'block',
              position: 'relative',
              cursor: 'pointer',
            }}
            onClick={() => {
              showTemplateModal(`${purchaseOrderContract.url}`)
            }}
            title={purchaseOrderContract.name}
          >
            {purchaseOrderContract?.name}
          </span>
          <CustomIcon
            style={{ position: 'absolute', top: '0', right: '-8px' }}
            type="icon-shanchu1"
            onClick={() => onClickDel(purchaseOrderContract)}
            className={styles.delicon}
          />
          <Button
            size="small"
            type="link"
            className={styles['download-text']}
            onClick={() => onClickDown(purchaseOrderContract)}
          >
            下载
          </Button>
        </div>
      </Col>
    )
  }

  const setIcon = (url: string) => {
    const iconType = url?.split('.').pop()?.toLowerCase()
    switch (iconType) {
      case 'xlsx':
        return <img src={xlsx} alt=""></img>
      case 'png':
        return <img src={img} alt=""></img>
      case 'pdf':
        return <img src={pdf} alt=""></img>
      case 'doc':
        return <img src={docx} alt=""></img>
      case 'docx':
        return <img src={docx} alt=""></img>
      default:
        return null
    }
  }

  const customerRender = () => {
    const customerInfoAttachments = detailInfo?.customerInfoAttachments
    return (
      <div>
        {customerInfoAttachments && customerInfoAttachments.length > 0 ? (
          customerInfoAttachments.map((item: fileFile, index: number) => (
            <Col key={index}>
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  cursor: 'pointer',
                  color: 'blue',
                }}
              >
                {setIcon(item.url)}
                <span
                  onClick={() => {
                    showPreviewModal(baseUrl + item.url)
                  }}
                  title={item.name}
                >
                  {(item.name?.length as number) > 20
                    ? item.name?.slice(0, 20) + '...'
                    : item.name}
                </span>

                <Button
                  size="small"
                  type="link"
                  onClick={() => onClickDown(item)}
                >
                  <DownloadOutlined style={{ color: '#3B44D3' }} />
                </Button>
              </div>
            </Col>
          ))
        ) : (
          <span>-</span>
        )}
      </div>
    )
  }

  /** 订单超期提示（与接口 shipmentOverdue / properOverdue 及 Desc 字段一致） */
  const buildOverdueBannerText = (): string | null => {
    const ship = detailInfo?.shipmentOverdue === true
    const proper = detailInfo?.properOverdue === true
    if (!ship && !proper) return null
    const segments = ['当前订单已超期']
    if (ship) {
      const desc = (detailInfo?.shipmentOverdueDesc ?? '').trim()
      segments.push(desc ? desc : '发货超期')
    }
    if (proper) {
      const desc = (detailInfo?.properOverdueDesc ?? '').trim()
      segments.push(desc ? desc : '妥投超期')
    }
    return segments.join('，')
  }

  const overdueBannerText = buildOverdueBannerText()

  const showOverdueBanner = Boolean(overdueBannerText)

  const descriptionFilesRender = () => {
    return (
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <Col>
          {orderDescriptionFiles.map((item, index) => (
            <div
              key={index}
              style={{
                display: 'flex',
                alignItems: 'center',
                position: 'relative',
              }}
            >
              <CustomIcon type="icon-wenjian1" style={{ fontSize: '20px' }} />
              <span
                className={styles['file-name']}
                style={{
                  textOverflow: 'ellipsis',
                  whiteSpace: 'nowrap',
                  maxWidth: '120px',
                  overflow: 'hidden',
                  display: 'block',
                  position: 'relative',
                  cursor: 'pointer',
                }}
                onClick={() => {
                  showTemplateModal(`${item.url}`)
                }}
                title={item.name}
              >
                {item?.name}
              </span>
              <CustomIcon
                style={{ position: 'absolute', top: '0', right: '-8px' }}
                type="icon-shanchu1"
                onClick={() => onClickDelDes(item)}
                className={styles.delicon}
              />
            </div>
          ))}
        </Col>
      </div>
    )
  }

  type AttachmentItem = {
    baseUrl: string
    id: string
    name: string
    url: string
  }

  const formConfig: {
    [x in orderdetailTabKey]: {
      listColumn: any[]
    }
  } = {
    商品明细: {
      listColumn: [
        {
          key: 'index',
          dataIndex: 'index',
          title: '序号',
          render: orderNoRender,
        },
        {
          key: 'progress',
          dataIndex: 'progress',
          title: '进度',
          filters: [
            {
              text: '未发',
              value: '1',
            },
            {
              text: '部分',
              value: '2',
            },
            {
              text: '完成',
              value: '3',
            },
          ],
          onFilter: (value: string, record: any) => {
            return value === record.progress
          },

          render: orderProgressRender,
        },
        {
          key: 'imgUrl',
          dataIndex: 'imgUrl',
          title: '商品图',
          render: thumbnailRender,
        },
        {
          key: 'code',
          dataIndex: 'code',
          title: '物料编码',
        },
        {
          key: 'platformMaterialCode',
          dataIndex: 'platformMaterialCode',
          title: '平台物资编码',
          render: (text: any) => text || '-',
        },
        {
          key: 'systemCategoryCode',
          dataIndex: 'systemCategoryCode',
          title: '物料品类',
          width: 150,
          render: (text: string) =>
            getDictLabel('SYSTEM.CATEGORY', text, dictData) || '-',
        },
        {
          key: 'brand',
          dataIndex: 'brand',
          title: '品牌',
        },
        {
          key: 'name',
          dataIndex: 'name',
          title: '商品名称',
        },
        {
          key: 'model',
          dataIndex: 'model',
          title: '型号',
        },
        {
          key: 'description',
          dataIndex: 'description',
          title: '物料描述',
          render: defaultRender,
        },
        {
          key: 'num',
          dataIndex: 'num',
          title: '数量',
        },
        {
          key: 'unit',
          dataIndex: 'unit',
          title: '单位',
        },
        {
          key: 'price',
          dataIndex: 'price',
          title: '单价',
        },
        {
          key: 'transferSupplierName',
          dataIndex: 'transferSupplierName',
          title: '被转派供应商',
        },
        {
          key: 'salePrice',
          dataIndex: 'salePrice',
          title: '市场价',
        },
        {
          key: 'remark',
          dataIndex: 'remark',
          title: '物料备注',
          render: (text: any) => text || '-',
        },
        {
          key: 'unCount',
          dataIndex: 'unCount',
          title: '未发数量',
        },
        {
          key: 'delCount',
          dataIndex: 'delCount',
          title: '已发数量',
        },
        {
          key: 'reCount',
          dataIndex: 'reCount',
          title: '退货数量',
        },
        {
          key: 'cancelCount',
          dataIndex: 'cancelCount',
          title: '取消数量',
          width: 100,
        },
      ],
    },
    发货明细: {
      listColumn: [
        {
          key: 'index',
          dataIndex: 'index',
          title: '序号',
          render: orderNoRender,
          width: 50,
        },
        {
          key: 'code',
          dataIndex: 'code',
          title: '物料编码',
          width: 100,
          ellipsis: true,
        },
        {
          key: 'brand',
          dataIndex: 'brand',
          title: '品牌',
          width: 140,
        },
        {
          key: 'name',
          dataIndex: 'name',
          title: '商品名称',
          width: 150,
        },
        {
          key: 'model',
          dataIndex: 'model',
          title: '型号',
          width: 150,
        },
        {
          key: 'num',
          dataIndex: 'num',
          title: '数量',
          width: 100,
        },
        {
          key: 'unit',
          dataIndex: 'unit',
          title: '单位',
          width: 80,
        },
        {
          key: 'price',
          dataIndex: 'price',
          title: '单价',
          width: 100,
        },
        {
          key: 'delCount',
          dataIndex: 'delCount',
          title: '已发数量',
          width: 100,
        },
      ],
    },
    退货明细: {
      listColumn: [
        {
          key: 'index',
          dataIndex: 'index',
          title: '序号',
          render: orderNoRender,
        },
        {
          key: 'productCode',
          dataIndex: 'productCode',
          title: '物料编码',
        },
        {
          key: 'brand',
          dataIndex: 'brand',
          title: '品牌',
        },
        {
          key: 'productName',
          dataIndex: 'productName',
          title: '商品名称',
        },
        {
          key: 'manuCode',
          dataIndex: 'manuCode',
          title: '规格型号',
        },
        {
          key: 'returnNum',
          dataIndex: 'returnNum',
          title: '退货数量',
        },

        {
          key: 'unit',
          dataIndex: 'unit',
          title: '单位',
        },
        {
          key: 'productPrice',
          dataIndex: 'productPrice',
          title: '单价',
        },
      ],
    },
    取消明细: {
      listColumn: [
        {
          key: 'index',
          dataIndex: 'index',
          title: '序号',
          render: orderNoRender,
          width: 50,
        },
        {
          key: 'code',
          dataIndex: 'code',
          title: '物料编码',
          width: 100,
        },
        {
          key: 'brand',
          dataIndex: 'brand',
          title: '品牌',
          width: 50,
        },
        {
          key: 'name',
          dataIndex: 'name',
          title: '商品名称',
          width: 100,
        },
        {
          key: 'model',
          dataIndex: 'model',
          title: '规格型号',
          width: 100,
        },
        {
          key: 'num',
          dataIndex: 'num',
          title: '取消数量',
          width: 100,
        },
        {
          key: 'unit',
          dataIndex: 'unit',
          title: '单位',
          width: 50,
        },
        {
          key: 'price',
          dataIndex: 'price',
          title: '单价',
          width: 50,
        },
      ],
    },
  }
  const certificateColumn = [
    {
      key: 'type',
      dataIndex: 'type',
      title: '凭证类型',
      render: (text: any) => {
        return certificateTypeDict?.[text] ?? ''
      },
    },
    {
      key: 'uploadMan',
      dataIndex: 'uploadMan',
      title: '提交人',
    },
    {
      key: 'createTime',
      dataIndex: 'createTime',
      title: '提交时间',
      render: (text: any) => {
        return text !== '-' && moment(text).format(timeFormatStr)
      },
    },
    {
      key: 'type',
      dataIndex: 'type',
      title: '凭证附件',
      render: (text: any, record: any) => {
        return (
          <div>
            {record?.acceptList?.map((item: AttachmentItem, index: number) => {
              return (
                <span key={item.url}>
                  <span
                    className="primaryBtn"
                    onClick={() => showPreviewModal(item.baseUrl + item.url)}
                  >{`附件${index + 1}`}</span>
                  {index + 1 < (record?.acceptList?.length ?? 0) ? (
                    <span
                      style={{
                        margin: '0 5px',
                      }}
                    >
                      ,
                    </span>
                  ) : null}
                </span>
              )
            })}
          </div>
        )
      },
    },
    {
      key: 'type',
      dataIndex: 'type',
      title: '操作',
      render: (text: any, record: any) => {
        return currentProgress === 3 ||
          record.auditState === '1' ||
          record.auditState === '3' ? (
          <span>-</span>
        ) : (
          <Space>
            <Tooltip title="修改">
              <EditOutlined
                className={styles['icon-size']}
                onClick={() => {
                  handleEditCertificate(record)
                }}
              />
            </Tooltip>
            <Tooltip title="刪除">
              <DeleteOutlined
                className={styles['icon-size']}
                onClick={() => handleDelCertificate(record)}
              />
            </Tooltip>
          </Space>
        )
      },
    },
  ]
  const renderDetialComponents = (keyname: orderdetailTabKey) => {
    switch (keyname) {
      case '商品明细':
        return (
          <CustomTable
            dataSource={productList}
            isLoading={isTableLoading}
            columns={formConfig['商品明细'].listColumn}
            onCheckChange={handleTableChangeCheck}
          ></CustomTable>
        )
      case '发货明细':
        if (detailListData?.deliveryList.length === 0)
          return (
            <div className={styles['empty-container']}>
              暂无发货数据，赶紧去发货吧
            </div>
          )
        else {
          return detailListData?.deliveryList.map((item, index) => {
            return (
              <div className={styles['delivery-container']} key={item.id}>
                <div className={styles['info-container']}>
                  <Row>
                    <Space>
                      <div className={styles['title']}>发货单{index + 1}</div>
                      <span className={styles['title']}>
                        时间：{item?.deliveryTime}
                      </span>
                    </Space>
                  </Row>
                  <Row justify="space-between">
                    <div>物流公司：{item?.expressCompany}</div>
                    {item?.expressCompany !== '厂家直发' && (
                      <div>快递单号：{item?.expressNo}</div>
                    )}
                    {item?.expressCompany === '厂家直发' && (
                      <div>送货人手机号：{item?.expressNo}</div>
                    )}
                    <div
                      style={{
                        color: 'black',
                      }}
                    >
                      签收状态：{item?.state}
                    </div>
                    {item.fileList &&
                      item.fileList.map(
                        (imgItem: AttachmentItem, imgIndex: number) => {
                          return (
                            <div
                              key={imgIndex}
                              onClick={() =>
                                showPreviewModal(baseUrl + imgItem.url)
                              }
                            >
                              附件：
                              <span className="primaryBtn">{imgItem.name}</span>
                            </div>
                          )
                        },
                      )}

                    <Link to={`/srm/deliveryorderdetail?id=${item.id}`}>
                      发货详情
                    </Link>
                  </Row>
                </div>
                <CustomTable
                  dataSource={item?.deliveryProductList}
                  isLoading={isTableLoading}
                  columns={formConfig['发货明细'].listColumn}
                ></CustomTable>
              </div>
            )
          })
        }
      case '退货明细':
        if (detailListData?.returnInfoList.length === 0)
          return <div className={styles['empty-container']}>暂无退货数据</div>
        else {
          return detailListData?.returnInfoList.map((item, index) => {
            return (
              <div className={styles['delivery-container']} key={item.returnNo}>
                <div className={styles['info-container']}>
                  <Row>
                    <Space>
                      <div className={styles['title']}>退货单{index + 1}</div>
                      <span className={styles['title']}>
                        时间：
                        {item &&
                          item.returnTime &&
                          moment(item.returnTime).format(timeFormatStr)}
                      </span>
                      <span className={styles['title']}>
                        <span>是否需要开红票：</span>
                        <span>
                          {shifouEnum.getLabelByValue(item.needRedInvoice) ||
                            '-'}
                        </span>
                      </span>
                      <span className={styles['title']}>
                        <span>红票开票状态：</span>
                        <span>
                          {redInvoiceStateEnum.getLabelByValue(
                            item.redInvoiceState,
                          ) || '-'}
                        </span>
                      </span>
                    </Space>
                  </Row>
                  <Row justify="space-between">
                    <div>退货单编号：{item?.returnNo}</div>
                    <div>退货金额：{item?.returnPrice}</div>
                    <div>
                      <span>状态：</span>
                      <span
                        style={{
                          color:
                            returnStateColorDict?.[
                              returnStateEnum.getLabelByValue(
                                item.state as any,
                              ) ?? '默认'
                            ],
                        }}
                      >
                        {returnStateEnum.getDisplayTextByValue(
                          item.state as any,
                        )}
                      </span>
                    </div>
                    <div></div>
                    {/* <Link to={`/srm/deliveryorderdetail?id=${item.id}`}>
                      发货详情
                    </Link> */}
                  </Row>
                </div>
                <CustomTable
                  rowKey={'productCode'}
                  dataSource={item?.returnDetailList}
                  isLoading={isTableLoading}
                  columns={formConfig['退货明细'].listColumn}
                ></CustomTable>
              </div>
            )
          })
        }
      case '取消明细':
        if (detailListData?.cancelInfoList?.length === 0)
          return <div className={styles['empty-container']}>暂无数据</div>
        else {
          return detailListData?.cancelInfoList?.map((item, index) => {
            return (
              <div className={styles['delivery-container']} key={item.cancelNo}>
                <div className={styles['info-container']}>
                  <Row>
                    <Space>
                      <div className={styles['title']}>取消单{index + 1}</div>
                      <span className={styles['title']}>
                        时间：
                        {item &&
                          item.createTime &&
                          moment(item.createTime).format(timeFormatStr)}
                      </span>
                    </Space>
                  </Row>
                  <Row justify="space-between">
                    <div>取消单编号：{item?.cancelNo}</div>
                    <div>取消金额：{item?.price}</div>
                    <div>
                      <span>状态：{item.statusValue}</span>
                    </div>
                    <div></div>
                  </Row>
                </div>
                <CustomTable
                  rowKey={'productCode'}
                  dataSource={item?.details}
                  isLoading={isTableLoading}
                  columns={formConfig['取消明细'].listColumn}
                ></CustomTable>
              </div>
            )
          })
        }
    }
  }

  const currentProgress = getCurrentProgress()
  return (
    <div className={styles['inner-content']}>
      <Steps current={getCurrentProgress()} progressDot>
        {progressList.map((item) => {
          return (
            <Step
              key={item.name}
              title={item.name}
              subTitle={item?.description}
              description={item?.time}
            ></Step>
          )
        })}
      </Steps>
      <div className={styles['order-info']}>
        <div
          className={styles['header']}
          style={{ justifyContent: 'space-between' }}
        >
          <Space>
            <span>客户订单号：{detailInfo?.orderNo}</span>
            <div>
              状态：
              {renderStateInfo(detailInfo?.orderState as stateKey)}
            </div>
            {showOverdueBanner ? (
              <div className={styles['overdue-banner-text']}>
                {overdueBannerText}
              </div>
            ) : null}
          </Space>
          <Space>
            {detailInfo?.supplierOrderId ? (
              <Button
                type="primary"
                className={styles['overdue-feedback-button']}
                icon={<WarningOutlined />}
                onClick={() => setOverdueFeedbackOpen(true)}
              >
                订单超期反馈
              </Button>
            ) : null}
            <Button onClick={() => openModal(true)}>订单说明</Button>
          </Space>
        </div>
        <div className={styles['content']}>
          <Row>
            <Col span={8}>
              <div className={styles['info-text-container']}>
                客户名称：{detailInfo?.customer}
              </div>
            </Col>
            <Col span={8}>
              <div className={styles['info-text-container']}>
                下单时间：{detailInfo?.createTime}
              </div>
            </Col>
            <Col span={8}>
              <div className={styles['info-text-container']}>
                派单时间：
                {moment(detailInfo?.dispatchTime).format('YYYY-MM-DD HH:mm:ss')}
              </div>
            </Col>
          </Row>
          <Row>
            <Col span={8}>
              <div className={styles['info-text-container']}>
                下单平台：{detailInfo?.platform}
              </div>
            </Col>
            <Col span={8}>
              <div className={styles['info-text-container']}>
                发货进度：{detailInfo?.progress}
              </div>
            </Col>
            <Col span={8}>
              <div className={styles['info-text-container']}>
                下单金额：{detailInfo?.price}
              </div>
            </Col>
          </Row>
          <Row>
            <Col span={8}>
              <div className={styles['info-text-container']}>
                退货金额：{detailInfo?.refundPrice}
              </div>
            </Col>
            <Col span={8}>
              <div className={styles['info-text-container']}>
                取消金额：{detailInfo?.cancelPrice}
              </div>
            </Col>
            <Col span={8}>
              <div className={styles['info-text-container']}>
                最终结算金额：{' '}
                {detailInfo?.orderState === '已完成'
                  ? detailInfo?.settlePrice
                  : '待订单完成后计算'}
              </div>
            </Col>
          </Row>
          <Row>
            <Col span={8}>
              <Space>
                <span>客户开票：{detailInfo?.invoicingState}</span>
                {currentProgress >= 2 ? (
                  <div>
                    {['开票中', '已开票'].includes(
                      detailInfo?.invoicingState ?? '',
                    ) && detailInfo?.orderInvoiceId ? (
                      <span className="btn-link" onClick={handleJumpInvoice}>
                        查看申请{'>>'}
                      </span>
                    ) : null}
                    {detailInfo?.invoicingState === '未开票' ? (
                      <span className="btn-link" onClick={handleJumpInvoice}>
                        前往申请{'>>'}
                      </span>
                    ) : null}
                  </div>
                ) : null}
              </Space>
            </Col>
            <Col span={8}>
              <div className={styles['info-text-container']}>
                对账完毕：{detailInfo?.returnState}
              </div>
            </Col>
            <Col span={8}>
              <div className={styles['info-text-container']}>
                回款方式：{detailInfo?.paymentMethodList?.join(',')}
              </div>
            </Col>
          </Row>
          <Row>
            <Col span={8}>
              <div className={styles['info-text-container']}>
                供应商开票：
                {
                  openInvoiceStateDictInvert?.[
                    detailInfo?.accountOpenInvoiceStatus ?? '1'
                  ]?.name
                }
              </div>
            </Col>
            <Col span={8}>
              <div className={styles['info-text-container']}>
                关联报备单：{detailInfo?.accountNo}
              </div>
            </Col>
            <Col span={8}>
              <div className={styles['info-text-container']}>
                <span>付款状态：</span>
                <Space>
                  <span>
                    {
                      paymentStatusDictInvert?.[
                        detailInfo?.paymentStatus ?? '1'
                      ]?.name
                    }
                  </span>
                  {detailInfo?.paymentStatus ===
                    paymentStatusDict['待申请'].numstr &&
                  !detailInfo?.prohibitionPaymentState &&
                  detailInfo?.settlePrice !== 0 ? (
                    <span
                      className="btn-link"
                      onClick={() =>
                        handleJumpAddPayment({
                          accountOpenInvoiceStatus:
                            accountOpenInvoiceStateDictInvert?.[
                              detailInfo?.accountOpenInvoiceStatus
                            ]?.name,
                          orderNo: detailInfo.orderNo,
                          customer: detailInfo.customer,
                          finalPrice: detailInfo?.settlePrice,
                          orderId: detailInfo.id,
                          orderPrice: detailInfo?.price,
                          orderState: detailInfo?.orderState,
                          orderTime: detailInfo?.createTime,
                          platform: detailInfo?.platform,
                          returnState: detailInfo?.returnState,
                          accountId: detailInfo?.accountId,
                          id: detailInfo.id,
                          signVoucherState:
                            detailInfo.signVoucherState as string,
                        })
                      }
                    >
                      {'前往申请>>'}
                    </span>
                  ) : null}
                  {[
                    paymentStatusDict['付款中'].numstr,
                    paymentStatusDict['付款完成'].numstr,
                  ].includes(detailInfo?.paymentStatus ?? '') ? (
                    <Link
                      to={`/srm/paymentrequestdetail?id=${detailInfo?.orderPaymentId}`}
                    >
                      {'查看详情>>'}
                    </Link>
                  ) : null}
                  {detailInfo?.paymentStatus ===
                  paymentStatusDict['不可付款'].numstr ? (
                    <Tippy
                      content={
                        <div className={styles['tooltip-card']}>
                          <Row className={styles['header']}>
                            满足以下条件可申请付款
                          </Row>
                          <Row className={styles['content']}>
                            <Space>
                              {(detailInfo?.confirmVoucherTime ?? null) !==
                              null ? (
                                <CheckOutlined
                                  style={{
                                    color: 'green',
                                  }}
                                />
                              ) : (
                                <CloseCircleOutlined
                                  style={{
                                    color: 'red',
                                  }}
                                />
                              )}
                              <span>签收凭证已确认</span>
                            </Space>
                          </Row>
                          <Row className={styles['content']}>
                            <Space>
                              {detailInfo?.returnState === '已完成' ? (
                                <CheckOutlined
                                  style={{
                                    color: 'green',
                                  }}
                                />
                              ) : (
                                <CloseCircleOutlined
                                  style={{
                                    color: 'red',
                                  }}
                                />
                              )}
                              <span>客户已回款</span>
                            </Space>
                          </Row>
                          <Row className={styles['content']}>
                            <Space>
                              {openInvoiceStateDictInvert?.[
                                detailInfo?.accountOpenInvoiceStatus ?? '1'
                              ]?.name === '已开票' ? (
                                <CheckOutlined
                                  style={{
                                    color: 'green',
                                  }}
                                />
                              ) : (
                                <CloseCircleOutlined
                                  style={{
                                    color: 'red',
                                  }}
                                />
                              )}
                              <span>供应商已开票</span>
                            </Space>
                          </Row>
                        </div>
                      }
                    >
                      <QuestionCircleOutlined />
                    </Tippy>
                  ) : null}
                </Space>
              </div>
            </Col>
          </Row>
          <Row>
            <Col span={8}>
              <div className={styles['info-text-container']}>
                客户备注：{detailInfo?.remark}
              </div>
            </Col>
            <Col span={8}>
              <div className={styles['info-text-container']}>
                签约抬头：
                {detailInfo?.titleOfTheContract ||
                  '万聚国际（杭州）供应链有限公司'}
              </div>
            </Col>
            <Col span={8}>
              <Space>
                采购合同：
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                  }}
                >
                  {detailInfo?.purchaseOrderContract ? (
                    filesRender()
                  ) : (
                    <Customupload
                      multiple={false}
                      textBtn="上传文件"
                      accept=".pdf,.gif,.png,.jpg,.jpeg,.doc,.docx"
                      uploadBtn={
                        <Button type="default" size="small">
                          上传合同
                          <UploadOutlined />
                        </Button>
                      }
                      beforeUpload={(a) => inTableUploadfile(a)}
                    />
                  )}
                  <Button
                    style={{ marginLeft: '10px' }}
                    onClick={() => downLoadTemplate()}
                  >
                    下载合同
                    <DownloadOutlined />
                  </Button>
                </div>
              </Space>
            </Col>
          </Row>
          <Row>
            <Col span={8}>
              <Space>
                客户资料：
                <div
                  style={{
                    display: 'flex',
                  }}
                >
                  {customerRender()}
                </div>
              </Space>
            </Col>
            <Col span={8}>
              <Space>
                订单备注：
                <div
                  style={{
                    display: 'flex',
                  }}
                >
                  {detailInfo?.orderRemark || '-'}
                </div>
              </Space>
            </Col>
          </Row>
        </div>
      </div>
      <div className={styles['sign-info']}>
        <div className={styles['header']}>
          <Row
            justify="space-between"
            style={{
              width: '100%',
            }}
          >
            <Space>
              <span>签收信息</span>
              <div>
                {currentProgress === 0 && (
                  <span className={styles['desp-info']}>
                    发货后可上传签收凭证
                  </span>
                )}
              </div>
              {(currentProgress === 2 || currentProgress === 1) &&
              detailInfo?.acceptAuditState === '1' ? (
                <span className={styles['desp-info']}>
                  咸亨审核中，请耐心等待
                </span>
              ) : (
                ''
              )}
              {(currentProgress === 2 || currentProgress === 1) &&
              detailInfo?.acceptAuditState === '2' ? (
                <>
                  <span className={styles['reject-info']}>
                    <span className={styles['reject-per']}>
                      驳回人：{detailInfo.acceptAuditMan}
                    </span>
                    <span>
                      驳回理由：
                      {detailInfo.acceptGroundsForRejection}
                    </span>
                  </span>
                </>
              ) : (
                ''
              )}
              {currentProgress === 3 &&
                detailInfo?.acceptAuditState === '3' && (
                  <span className={styles['success-info']}>签收凭证已确认</span>
                )}
            </Space>
            <div>
              {(currentProgress === 1 && !detailInfo?.acceptInfoDTOS.length) ||
              (currentProgress === 2 && !detailInfo?.acceptInfoDTOS.length) ||
              (detailInfo?.acceptInfoDTOS.length &&
                !detailInfo?.acceptAuditState) ||
              (detailInfo?.acceptInfoDTOS.length &&
                (detailInfo?.acceptAuditState === '2' ||
                  detailInfo?.acceptAuditState === '4')) ? (
                <Space>
                  <Button onClick={downloadCustomCertificate}>
                    下载客户定制验收单
                  </Button>
                  <Button onClick={downloadAllCertificate}>
                    下载咸亨标准验收单
                  </Button>
                  <Button onClick={showUploadCertificateModal}>上传凭证</Button>
                  <Button type="primary" onClick={saveAndSubmitCheck}>
                    保存并提交审核
                  </Button>
                </Space>
              ) : // 订单状态为待履约时支持下载咸亨标准验收单功能
              detailInfo?.orderState === '待履约' ? (
                <Space>
                  <Button onClick={downloadCustomCertificate}>
                    下载客户定制验收单
                  </Button>
                  <Button onClick={downloadAllCertificate}>
                    下载咸亨标准验收单
                  </Button>
                </Space>
              ) : null}
            </div>
          </Row>
        </div>
        <Row className={styles['content']}>
          <Col span={8}>
            <div className={styles['info-text-container']}>
              收件人：{detailInfo?.consignee}
            </div>
          </Col>
          <Col span={8}>
            <div className={styles['info-text-container']}>
              联系方式：{detailInfo?.mobile}
            </div>
          </Col>
          <Col span={8}>
            <div className={styles['info-text-container']}>
              收货地址：{detailInfo?.address}
            </div>
          </Col>
        </Row>
        <div className={styles['content']}>
          {(detailInfo?.acceptInfoDTOS?.length ?? 0) > 0 ? (
            <CustomTable
              columns={certificateColumn}
              dataSource={detailInfo?.acceptInfoDTOS}
            ></CustomTable>
          ) : null}
        </div>
      </div>
      <div className={styles['tab-container']}>
        <Spin spinning={loading}>
          <Tabs
            tabBarExtraContent={
              <Space>
                {detailInfo?.orderTransferSupported === true ? (
                  <Tooltip title="支持将订单转派给另一家供应商，转派后您将无法操作转派的物料行，请根据实际情况谨慎操作！">
                    <Button
                      type="primary"
                      className={styles['submit-button']}
                      onClick={handleOrderTransferClick}
                    >
                      订单转派
                    </Button>
                  </Tooltip>
                ) : null}

                {detailInfo?.checkState === '1' ? (
                  <Tooltip
                    title={
                      <div className={styles['tooltip-card']}>
                        <div className={styles['card-title']}>无法发货说明</div>
                        <div className={styles['card-content']}>
                          客户在平台发起了订单取消申请，平台管理员审核中，请勿发货!
                        </div>
                      </div>
                    }
                    placement="topLeft"
                  >
                    <div className={styles['info-text']}>
                      <InfoCircleFilled />
                    </div>
                  </Tooltip>
                ) : null}

                {['履约中', '待履约'].includes(
                  detailInfo?.orderState ?? 'invalid-state',
                ) ? (
                  <Button
                    type="primary"
                    className={styles['submit-button']}
                    onClick={handleDeliveryClick}
                    disabled={
                      (productList || []).filter((item: any) => {
                        return item?.isDisabled !== true
                      }).length >= 1
                        ? false
                        : true
                    }
                  >
                    发货
                  </Button>
                ) : null}
              </Space>
            }
          >
            {orderdetailTabKeyList.map((keyname) => {
              return (
                <Tabs.TabPane tab={keyname} key={keyname}>
                  {renderDetialComponents(keyname)}
                </Tabs.TabPane>
              )
            })}
          </Tabs>
        </Spin>
      </div>
      <OverdueFeedbackModal
        open={overdueFeedbackOpen}
        orderId={detailInfo?.id || ''}
        onCancel={() => setOverdueFeedbackOpen(false)}
        onSuccess={() => {
          setOverdueFeedbackOpen(false)
          refreshData()
        }}
      />
      <div
        className={styles['order-info']}
        style={{
          marginTop: '20px',
        }}
      >
        <div className={styles['header']}>
          <Space>
            <span>发票信息</span>
          </Space>
        </div>
        <div className={styles['content']}>
          <Row>
            <Col span={8}>
              <span>发票类型：</span>
              <span>{invoiceInfo?.invoiceTypeStr}</span>
            </Col>
            <Col span={8}>
              <span>开票抬头：</span>
              <span>{invoiceInfo?.invoiceTitle}</span>
            </Col>
            <Col span={8}>
              <span>纳税识别号：</span>
              <span>{invoiceInfo?.taxCode}</span>
            </Col>
          </Row>
          <Row>
            <Col span={8}>
              <span>开户行：</span>
              <span>{invoiceInfo?.bankName}</span>
            </Col>
            <Col span={8}>
              <span>银行账户：</span>
              <span>{invoiceInfo?.bankAccount}</span>
            </Col>
            <Col span={8}>
              <span>开票电话：</span>
              <span>{invoiceInfo?.openInvoiceMobile}</span>
            </Col>
          </Row>
          <Row>
            <Col span={8}>
              <span>开票地址：</span>
              <span>{invoiceInfo?.invoiceAddress}</span>
            </Col>
            <Col span={16}>
              <span>票面信息：</span>
              <span>{invoiceInfo?.invoiceFaceInfo}</span>
            </Col>
          </Row>
          <Row>
            <Col span={8}>
              <span>发票接收人：</span>
              <span>{invoiceInfo?.receiveMan}</span>
            </Col>
            <Col span={8}>
              <span>联系人电话：</span>
              <span>{invoiceInfo?.mobile}</span>
            </Col>
            <Col span={8}>
              <span>收票地址：</span>
              <span>{invoiceInfo?.receiveAddress}</span>
            </Col>
          </Row>
        </div>
      </div>
      <UploadCertificateModal
        open={uploadCertificateModalOption.visible}
        onCancel={cancelUploadCertificateModal}
        detailInfo={detailInfo as any}
        onSubmitEnd={handleSubmitEnd}
        getAddOrderAccept={getAddOrderAccept}
        currentEditItem={currentEditCertificate}
      ></UploadCertificateModal>
      <PreviewModal
        open={isPreviewModalVisible}
        fileUrl={previewFileUrl}
        onCancel={cancelPreviewModal}
        waterMarkOption={waterMarkOption}
      />
      <Modal
        title={
          <>
            订单说明
            <Tooltip
              getPopupContainer={() => document.body}
              title="任何情况您都可以提供详细说明反馈给咸亨，系统支持文本输入和文件上传。"
            >
              <QuestionCircleFilled style={{ marginLeft: '3px' }} />
            </Tooltip>
          </>
        }
        destroyOnClose={true}
        width={'1000px'}
        open={isOpenModal}
        onCancel={() => openModal(false)}
        onOk={submitRichText}
        okText="提交"
        cancelText="取消"
      >
        <BraftEditor
          ref={richTextRef}
          saveEditorContent={handleContentChange}
          dataSource={richText}
        />
        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
          <div>
            <span> 上传附件：</span>
            {orderDescriptionFiles.length < 3 && (
              <Customupload
                multiple={false}
                textBtn="上传附件"
                accept=".pdf,.gif,.png,.jpg,.jpeg,.doc,.docx"
                uploadBtn={
                  <Button type="default" size="small">
                    上传附件
                    <UploadOutlined />
                  </Button>
                }
                beforeUpload={(a) => uploadRichfile(a)}
              />
            )}

            {orderDescriptionFiles.length > 0 && descriptionFilesRender()}
          </div>

          <span>最多输入500字</span>
        </div>
      </Modal>
    </div>
  )
}
import { useState } from 'react'
import UserOrderDetailHook from './hooks'
import {
  InfoCircleFilled,
  DeleteOutlined,
  EditOutlined,
  CheckOutlined,
  LoadingOutlined,
  DownloadOutlined,
  UploadOutlined,
  QuestionCircleFilled,
  WarningOutlined,
} from '@ant-design/icons'
import styles from './style.module.scss'
import {
  Button,
  Col,
  Row,
  Space,
  Tooltip,
  Spin,
  Tabs,
  Steps,
  Tag,
  Modal,
} from 'antd'
import { Link } from 'react-router-dom'
import CustomTable from '../../components/CustomTable'
import { UploadCertificateModal } from '../../modules/orderdetail/uploadCertificateModal'
import { certificateTypeDict } from '../../api/orderManage'
import moment from 'moment'
import { GetLocalStorage, timeFormatStr } from '../../tools/util'
import Tippy from '@tippyjs/react'
import { QuestionCircleOutlined, CloseCircleOutlined } from '@ant-design/icons'
import {
  accountOpenInvoiceStateDictInvert,
  openInvoiceStateDictInvert,
  paymentStatusDict,
  paymentStatusDictInvert,
  returnStateEnum,
} from '../../tools/state'
import { handleJumpAddPayment } from '../payable-orders/hooks'
import PreviewModal, {
  DefaultWaterMarkOption,
} from '../../components/previewModal'
import ThumbnailPreview from '../../components/ThumbnailPreview'
import { orderdetailTabKey, orderdetailTabKeyList } from './reducer'
import Customupload from '@/components/UploadFile'
import CustomIcon from '@/components/IconUser'
import BraftEditor from '../../components/BraftEditer'
import { fileFile } from '@/modules/goodsdetailmodules/uploadfiles'
import OverdueFeedbackModal from './components/OverdueFeedbackModal'
import xlsx from '../../assets/img/EXCEL.png'
import img from '../../assets/img/IMG.png'
import pdf from '../../assets/img/PDF.png'
import docx from '../../assets/img/WORD.png'
const { Step } = Steps

import { Form, Input } from 'antd'
import { defaultRender } from '@/tools/table'
import { redInvoiceStateEnum, shifouEnum } from '@/global/enum'
import { useTypedSelector } from '@/redux/store'
import {
  getDictList,
  getDictLabel,
  getDictOptions,
  getDictValue,
} from '@/modules/dict'
export const orderNoRender = (text: any, record: any, index: number) => {
  return index + 1 + ''
}
// 发货进度判断
export const stateColorDict: any = {
  已签收: 'green',
  待收货: 'lightblue',
}
export const returnStateColorDict: any = {
  已退货: 'green',
  退货中: 'lightblue',
  默认: 'black',
}
export function useThumbnailRenderHook() {
  const thumbnailRender = (text: any) => {
    return text ? <ThumbnailPreview src={text}></ThumbnailPreview> : ''
  }
  return { thumbnailRender }
}

export const orderStateDict = {
  待履约: {
    tagColor: 'orange',
    desp: '请核对订单并发货',
  },
  履约中: {
    tagColor: 'orange',
    desp: '请将所有物料全部发货',
  },
  待验收: {
    tagColor: 'orange',
    desp: '上传签收凭证，并等待咸亨确认',
  },
  撤回: {
    tagColor: 'default',
    desp: '已撤回，无需履约',
  },
  已取消: {
    tagColor: 'default',
    desp: '已取消，无需履约',
  },
  已完成: {
    tagColor: 'success',
    desp: '客户回款后可对账',
  },
}
export type stateKey = keyof typeof orderStateDict

export const renderStateInfo = (orderState: stateKey) => {
  const isValidState = Object.keys(orderStateDict).includes(orderState)
  if (isValidState) {
    const info = orderStateDict?.[orderState as stateKey]
    return (
      <Space>
        <Tag color={info.tagColor}>{orderState}</Tag>
        <span className={styles['desp-info']}>{info?.desp}</span>
      </Space>
    )
  } else {
    return <Tag>{orderState}</Tag>
  }
}

export default function OrderDetail() {
  const [overdueFeedbackOpen, setOverdueFeedbackOpen] = useState(false)
  const {
    baseUrl,
    hookstate,
    progressList,
    getCurrentProgress,
    handleJumpInvoice,
    handleDeliveryClick,
    handleOrderTransferClick,
    handleTableChangeCheck,
    showUploadCertificateModal,
    cancelUploadCertificateModal,
    handleDelCertificate,
    handleEditCertificate,
    handleSubmitEnd,
    downloadAllCertificate,
    downloadCustomCertificate,
    showPreviewModal,
    cancelPreviewModal,
    saveAndSubmitCheck,
    getAddOrderAccept,
    downLoadTemplate,
    inTableUploadfile,
    onClickDown,
    showTemplateModal,
    onClickDel,
    openModal,
    handleContentChange,
    submitRichText,
    uploadRichfile,
    onClickDelDes,
    richTextRef,
    refreshData,
  } = UserOrderDetailHook()
  const {
    detailInfo,
    isTableLoading,
    productList,
    loading,
    isPreviewModalVisible,
    previewFileUrl,
    uploadCertificateModalOption,
    currentEditCertificate,
    invoiceInfo,
    waterMarkOption,
    detailListData,
    isOpenModal,
    richText,
    orderDescriptionFiles,
  } = hookstate

  // 获取字典数据
  const dictData = useTypedSelector((state) => state.dictData.dictData)

  console.log(dictData, 'dictData')

  // 使用字典的示例：
  // 1. 获取字典列表
  // const statusList = getDictList('status', dictData)

  // 2. 根据值获取标签
  // const statusLabel = getDictLabel('status', '1', dictData)

  // 3. 获取 Select 选项
  // const statusOptions = getDictOptions('status', dictData)

  // 4. 根据标签获取值
  // const statusValue = getDictValue('status', '启用', dictData)

  const orderProgressRender = (text: any) => {
    const progressObj: any = {
      '1': { text: '未发', color: 'red' },
      '2': { text: '部分', color: 'black' },
      '3': { text: '完成', color: 'green' },
    }
    return (
      <span style={{ color: progressObj[text]?.color }}>
        {progressObj[text]?.text}
      </span>
    )
  }

  const thumbnailRender = (text: any) =>
    text === 'loading' ? (
      <LoadingOutlined />
    ) : (
      <img
        src={
          text || `${GetLocalStorage('BASEURL')}ui-common-imgs/default_pic.svg`
        }
        alt=""
        style={{
          width: '20px',
          height: '20px',
          objectFit: 'contain',
          cursor: 'pointer',
        }}
        onClick={() => text && showPreviewModal(text, DefaultWaterMarkOption)}
      />
    )

  const filesRender = () => {
    const purchaseOrderContract = detailInfo?.purchaseOrderContract
    return (
      <Col>
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <CustomIcon type="icon-wenjian1" style={{ fontSize: '20px' }} />
          <span
            className={styles['file-name']}
            style={{
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
              maxWidth: '120px',
              overflow: 'hidden',
              display: 'block',
              position: 'relative',
              cursor: 'pointer',
            }}
            onClick={() => {
              showTemplateModal(`${purchaseOrderContract.url}`)
            }}
            title={purchaseOrderContract.name}
          >
            {purchaseOrderContract?.name}
          </span>
          <CustomIcon
            style={{ position: 'absolute', top: '0', right: '-8px' }}
            type="icon-shanchu1"
            onClick={() => onClickDel(purchaseOrderContract)}
            className={styles.delicon}
          />
          <Button
            size="small"
            type="link"
            className={styles['download-text']}
            onClick={() => onClickDown(purchaseOrderContract)}
          >
            下载
          </Button>
        </div>
      </Col>
    )
  }

  const setIcon = (url: string) => {
    const iconType = url?.split('.').pop()?.toLowerCase()
    switch (iconType) {
      case 'xlsx':
        return <img src={xlsx} alt=""></img>
      case 'png':
        return <img src={img} alt=""></img>
      case 'pdf':
        return <img src={pdf} alt=""></img>
      case 'doc':
        return <img src={docx} alt=""></img>
      case 'docx':
        return <img src={docx} alt=""></img>
      default:
        return null
    }
  }

  const customerRender = () => {
    const customerInfoAttachments = detailInfo?.customerInfoAttachments
    return (
      <div>
        {customerInfoAttachments && customerInfoAttachments.length > 0 ? (
          customerInfoAttachments.map((item: fileFile, index: number) => (
            <Col key={index}>
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  cursor: 'pointer',
                  color: 'blue',
                }}
              >
                {setIcon(item.url)}
                <span
                  onClick={() => {
                    showPreviewModal(baseUrl + item.url)
                  }}
                  title={item.name}
                >
                  {(item.name?.length as number) > 20
                    ? item.name?.slice(0, 20) + '...'
                    : item.name}
                </span>

                <Button
                  size="small"
                  type="link"
                  onClick={() => onClickDown(item)}
                >
                  <DownloadOutlined style={{ color: '#3B44D3' }} />
                </Button>
              </div>
            </Col>
          ))
        ) : (
          <span>-</span>
        )}
      </div>
    )
  }

  /** 订单超期提示（与接口 shipmentOverdue / properOverdue 及 Desc 字段一致） */
  const buildOverdueBannerText = (): string | null => {
    const ship = detailInfo?.shipmentOverdue === true
    const proper = detailInfo?.properOverdue === true
    if (!ship && !proper) return null
    const segments = ['当前订单已超期']
    if (ship) {
      const desc = (detailInfo?.shipmentOverdueDesc ?? '').trim()
      segments.push(desc ? desc : '发货超期')
    }
    if (proper) {
      const desc = (detailInfo?.properOverdueDesc ?? '').trim()
      segments.push(desc ? desc : '妥投超期')
    }
    return segments.join('，')
  }

  const overdueBannerText = buildOverdueBannerText()

  const showOverdueBanner = Boolean(overdueBannerText)

  const descriptionFilesRender = () => {
    return (
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <Col>
          {orderDescriptionFiles.map((item, index) => (
            <div
              key={index}
              style={{
                display: 'flex',
                alignItems: 'center',
                position: 'relative',
              }}
            >
              <CustomIcon type="icon-wenjian1" style={{ fontSize: '20px' }} />
              <span
                className={styles['file-name']}
                style={{
                  textOverflow: 'ellipsis',
                  whiteSpace: 'nowrap',
                  maxWidth: '120px',
                  overflow: 'hidden',
                  display: 'block',
                  position: 'relative',
                  cursor: 'pointer',
                }}
                onClick={() => {
                  showTemplateModal(`${item.url}`)
                }}
                title={item.name}
              >
                {item?.name}
              </span>
              <CustomIcon
                style={{ position: 'absolute', top: '0', right: '-8px' }}
                type="icon-shanchu1"
                onClick={() => onClickDelDes(item)}
                className={styles.delicon}
              />
            </div>
          ))}
        </Col>
      </div>
    )
  }

  type AttachmentItem = {
    baseUrl: string
    id: string
    name: string
    url: string
  }

  const formConfig: {
    [x in orderdetailTabKey]: {
      listColumn: any[]
    }
  } = {
    商品明细: {
      listColumn: [
        {
          key: 'index',
          dataIndex: 'index',
          title: '序号',
          render: orderNoRender,
        },
        {
          key: 'progress',
          dataIndex: 'progress',
          title: '进度',
          filters: [
            {
              text: '未发',
              value: '1',
            },
            {
              text: '部分',
              value: '2',
            },
            {
              text: '完成',
              value: '3',
            },
          ],
          onFilter: (value: string, record: any) => {
            return value === record.progress
          },

          render: orderProgressRender,
        },
        {
          key: 'imgUrl',
          dataIndex: 'imgUrl',
          title: '商品图',
          render: thumbnailRender,
        },
        {
          key: 'code',
          dataIndex: 'code',
          title: '物料编码',
        },
        {
          key: 'platformMaterialCode',
          dataIndex: 'platformMaterialCode',
          title: '平台物资编码',
          render: (text: any) => text || '-',
        },
        {
          key: 'systemCategoryCode',
          dataIndex: 'systemCategoryCode',
          title: '物料品类',
          width: 150,
          render: (text: string) =>
            getDictLabel('SYSTEM.CATEGORY', text, dictData) || '-',
        },
        {
          key: 'brand',
          dataIndex: 'brand',
          title: '品牌',
        },
        {
          key: 'name',
          dataIndex: 'name',
          title: '商品名称',
        },
        {
          key: 'model',
          dataIndex: 'model',
          title: '型号',
        },
        {
          key: 'description',
          dataIndex: 'description',
          title: '物料描述',
          render: defaultRender,
        },
        {
          key: 'num',
          dataIndex: 'num',
          title: '数量',
        },
        {
          key: 'unit',
          dataIndex: 'unit',
          title: '单位',
        },
        {
          key: 'price',
          dataIndex: 'price',
          title: '单价',
        },
        {
          key: 'transferSupplierName',
          dataIndex: 'transferSupplierName',
          title: '被转派供应商',
        },
        {
          key: 'salePrice',
          dataIndex: 'salePrice',
          title: '市场价',
        },
        {
          key: 'remark',
          dataIndex: 'remark',
          title: '物料备注',
          render: (text: any) => text || '-',
        },
        {
          key: 'unCount',
          dataIndex: 'unCount',
          title: '未发数量',
        },
        {
          key: 'delCount',
          dataIndex: 'delCount',
          title: '已发数量',
        },
        {
          key: 'reCount',
          dataIndex: 'reCount',
          title: '退货数量',
        },
        {
          key: 'cancelCount',
          dataIndex: 'cancelCount',
          title: '取消数量',
          width: 100,
        },
      ],
    },
    发货明细: {
      listColumn: [
        {
          key: 'index',
          dataIndex: 'index',
          title: '序号',
          render: orderNoRender,
          width: 50,
        },
        {
          key: 'code',
          dataIndex: 'code',
          title: '物料编码',
          width: 100,
          ellipsis: true,
        },
        {
          key: 'brand',
          dataIndex: 'brand',
          title: '品牌',
          width: 140,
        },
        {
          key: 'name',
          dataIndex: 'name',
          title: '商品名称',
          width: 150,
        },
        {
          key: 'model',
          dataIndex: 'model',
          title: '型号',
          width: 150,
        },
        {
          key: 'num',
          dataIndex: 'num',
          title: '数量',
          width: 100,
        },
        {
          key: 'unit',
          dataIndex: 'unit',
          title: '单位',
          width: 80,
        },
        {
          key: 'price',
          dataIndex: 'price',
          title: '单价',
          width: 100,
        },
        {
          key: 'delCount',
          dataIndex: 'delCount',
          title: '已发数量',
          width: 100,
        },
      ],
    },
    退货明细: {
      listColumn: [
        {
          key: 'index',
          dataIndex: 'index',
          title: '序号',
          render: orderNoRender,
        },
        {
          key: 'productCode',
          dataIndex: 'productCode',
          title: '物料编码',
        },
        {
          key: 'brand',
          dataIndex: 'brand',
          title: '品牌',
        },
        {
          key: 'productName',
          dataIndex: 'productName',
          title: '商品名称',
        },
        {
          key: 'manuCode',
          dataIndex: 'manuCode',
          title: '规格型号',
        },
        {
          key: 'returnNum',
          dataIndex: 'returnNum',
          title: '退货数量',
        },

        {
          key: 'unit',
          dataIndex: 'unit',
          title: '单位',
        },
        {
          key: 'productPrice',
          dataIndex: 'productPrice',
          title: '单价',
        },
      ],
    },
    取消明细: {
      listColumn: [
        {
          key: 'index',
          dataIndex: 'index',
          title: '序号',
          render: orderNoRender,
          width: 50,
        },
        {
          key: 'code',
          dataIndex: 'code',
          title: '物料编码',
          width: 100,
        },
        {
          key: 'brand',
          dataIndex: 'brand',
          title: '品牌',
          width: 50,
        },
        {
          key: 'name',
          dataIndex: 'name',
          title: '商品名称',
          width: 100,
        },
        {
          key: 'model',
          dataIndex: 'model',
          title: '规格型号',
          width: 100,
        },
        {
          key: 'num',
          dataIndex: 'num',
          title: '取消数量',
          width: 100,
        },
        {
          key: 'unit',
          dataIndex: 'unit',
          title: '单位',
          width: 50,
        },
        {
          key: 'price',
          dataIndex: 'price',
          title: '单价',
          width: 50,
        },
      ],
    },
  }
  const certificateColumn = [
    {
      key: 'type',
      dataIndex: 'type',
      title: '凭证类型',
      render: (text: any) => {
        return certificateTypeDict?.[text] ?? ''
      },
    },
    {
      key: 'uploadMan',
      dataIndex: 'uploadMan',
      title: '提交人',
    },
    {
      key: 'createTime',
      dataIndex: 'createTime',
      title: '提交时间',
      render: (text: any) => {
        return text !== '-' && moment(text).format(timeFormatStr)
      },
    },
    {
      key: 'type',
      dataIndex: 'type',
      title: '凭证附件',
      render: (text: any, record: any) => {
        return (
          <div>
            {record?.acceptList?.map((item: AttachmentItem, index: number) => {
              return (
                <span key={item.url}>
                  <span
                    className="primaryBtn"
                    onClick={() => showPreviewModal(item.baseUrl + item.url)}
                  >{`附件${index + 1}`}</span>
                  {index + 1 < (record?.acceptList?.length ?? 0) ? (
                    <span
                      style={{
                        margin: '0 5px',
                      }}
                    >
                      ,
                    </span>
                  ) : null}
                </span>
              )
            })}
          </div>
        )
      },
    },
    {
      key: 'type',
      dataIndex: 'type',
      title: '操作',
      render: (text: any, record: any) => {
        return currentProgress === 3 ||
          record.auditState === '1' ||
          record.auditState === '3' ? (
          <span>-</span>
        ) : (
          <Space>
            <Tooltip title="修改">
              <EditOutlined
                className={styles['icon-size']}
                onClick={() => {
                  handleEditCertificate(record)
                }}
              />
            </Tooltip>
            <Tooltip title="刪除">
              <DeleteOutlined
                className={styles['icon-size']}
                onClick={() => handleDelCertificate(record)}
              />
            </Tooltip>
          </Space>
        )
      },
    },
  ]
  const renderDetialComponents = (keyname: orderdetailTabKey) => {
    switch (keyname) {
      case '商品明细':
        return (
          <CustomTable
            dataSource={productList}
            isLoading={isTableLoading}
            columns={formConfig['商品明细'].listColumn}
            onCheckChange={handleTableChangeCheck}
          ></CustomTable>
        )
      case '发货明细':
        if (detailListData?.deliveryList.length === 0)
          return (
            <div className={styles['empty-container']}>
              暂无发货数据，赶紧去发货吧
            </div>
          )
        else {
          return detailListData?.deliveryList.map((item, index) => {
            return (
              <div className={styles['delivery-container']} key={item.id}>
                <div className={styles['info-container']}>
                  <Row>
                    <Space>
                      <div className={styles['title']}>发货单{index + 1}</div>
                      <span className={styles['title']}>
                        时间：{item?.deliveryTime}
                      </span>
                    </Space>
                  </Row>
                  <Row justify="space-between">
                    <div>物流公司：{item?.expressCompany}</div>
                    {item?.expressCompany !== '厂家直发' && (
                      <div>快递单号：{item?.expressNo}</div>
                    )}
                    {item?.expressCompany === '厂家直发' && (
                      <div>送货人手机号：{item?.expressNo}</div>
                    )}
                    <div
                      style={{
                        color: 'black',
                      }}
                    >
                      签收状态：{item?.state}
                    </div>
                    {item.fileList &&
                      item.fileList.map(
                        (imgItem: AttachmentItem, imgIndex: number) => {
                          return (
                            <div
                              key={imgIndex}
                              onClick={() =>
                                showPreviewModal(baseUrl + imgItem.url)
                              }
                            >
                              附件：
                              <span className="primaryBtn">{imgItem.name}</span>
                            </div>
                          )
                        },
                      )}

                    <Link to={`/srm/deliveryorderdetail?id=${item.id}`}>
                      发货详情
                    </Link>
                  </Row>
                </div>
                <CustomTable
                  dataSource={item?.deliveryProductList}
                  isLoading={isTableLoading}
                  columns={formConfig['发货明细'].listColumn}
                ></CustomTable>
              </div>
            )
          })
        }
      case '退货明细':
        if (detailListData?.returnInfoList.length === 0)
          return <div className={styles['empty-container']}>暂无退货数据</div>
        else {
          return detailListData?.returnInfoList.map((item, index) => {
            return (
              <div className={styles['delivery-container']} key={item.returnNo}>
                <div className={styles['info-container']}>
                  <Row>
                    <Space>
                      <div className={styles['title']}>退货单{index + 1}</div>
                      <span className={styles['title']}>
                        时间：
                        {item &&
                          item.returnTime &&
                          moment(item.returnTime).format(timeFormatStr)}
                      </span>
                      <span className={styles['title']}>
                        <span>是否需要开红票：</span>
                        <span>
                          {shifouEnum.getLabelByValue(item.needRedInvoice) ||
                            '-'}
                        </span>
                      </span>
                      <span className={styles['title']}>
                        <span>红票开票状态：</span>
                        <span>
                          {redInvoiceStateEnum.getLabelByValue(
                            item.redInvoiceState,
                          ) || '-'}
                        </span>
                      </span>
                    </Space>
                  </Row>
                  <Row justify="space-between">
                    <div>退货单编号：{item?.returnNo}</div>
                    <div>退货金额：{item?.returnPrice}</div>
                    <div>
                      <span>状态：</span>
                      <span
                        style={{
                          color:
                            returnStateColorDict?.[
                              returnStateEnum.getLabelByValue(
                                item.state as any,
                              ) ?? '默认'
                            ],
                        }}
                      >
                        {returnStateEnum.getDisplayTextByValue(
                          item.state as any,
                        )}
                      </span>
                    </div>
                    <div></div>
                    {/* <Link to={`/srm/deliveryorderdetail?id=${item.id}`}>
                      发货详情
                    </Link> */}
                  </Row>
                </div>
                <CustomTable
                  rowKey={'productCode'}
                  dataSource={item?.returnDetailList}
                  isLoading={isTableLoading}
                  columns={formConfig['退货明细'].listColumn}
                ></CustomTable>
              </div>
            )
          })
        }
      case '取消明细':
        if (detailListData?.cancelInfoList?.length === 0)
          return <div className={styles['empty-container']}>暂无数据</div>
        else {
          return detailListData?.cancelInfoList?.map((item, index) => {
            return (
              <div className={styles['delivery-container']} key={item.cancelNo}>
                <div className={styles['info-container']}>
                  <Row>
                    <Space>
                      <div className={styles['title']}>取消单{index + 1}</div>
                      <span className={styles['title']}>
                        时间：
                        {item &&
                          item.createTime &&
                          moment(item.createTime).format(timeFormatStr)}
                      </span>
                    </Space>
                  </Row>
                  <Row justify="space-between">
                    <div>取消单编号：{item?.cancelNo}</div>
                    <div>取消金额：{item?.price}</div>
                    <div>
                      <span>状态：{item.statusValue}</span>
                    </div>
                    <div></div>
                  </Row>
                </div>
                <CustomTable
                  rowKey={'productCode'}
                  dataSource={item?.details}
                  isLoading={isTableLoading}
                  columns={formConfig['取消明细'].listColumn}
                ></CustomTable>
              </div>
            )
          })
        }
    }
  }

  const currentProgress = getCurrentProgress()
  return (
    <div className={styles['inner-content']}>
      <Steps current={getCurrentProgress()} progressDot>
        {progressList.map((item) => {
          return (
            <Step
              key={item.name}
              title={item.name}
              subTitle={item?.description}
              description={item?.time}
            ></Step>
          )
        })}
      </Steps>
      <div className={styles['order-info']}>
        <div
          className={styles['header']}
          style={{ justifyContent: 'space-between' }}
        >
          <Space>
            <span>客户订单号：{detailInfo?.orderNo}</span>
            <div>
              状态：
              {renderStateInfo(detailInfo?.orderState as stateKey)}
            </div>
            {showOverdueBanner ? (
              <div className={styles['overdue-banner-text']}>
                {overdueBannerText}
              </div>
            ) : null}
          </Space>
          <Space>
            {detailInfo?.supplierOrderId ? (
              <Button
                type="primary"
                className={styles['overdue-feedback-button']}
                icon={<WarningOutlined />}
                onClick={() => setOverdueFeedbackOpen(true)}
              >
                订单超期反馈
              </Button>
            ) : null}
            <Button onClick={() => openModal(true)}>订单说明</Button>
          </Space>
        </div>
        <div className={styles['content']}>
          <Row>
            <Col span={8}>
              <div className={styles['info-text-container']}>
                客户名称：{detailInfo?.customer}
              </div>
            </Col>
            <Col span={8}>
              <div className={styles['info-text-container']}>
                下单时间：{detailInfo?.createTime}
              </div>
            </Col>
            <Col span={8}>
              <div className={styles['info-text-container']}>
                派单时间：
                {moment(detailInfo?.dispatchTime).format('YYYY-MM-DD HH:mm:ss')}
              </div>
            </Col>
          </Row>
          <Row>
            <Col span={8}>
              <div className={styles['info-text-container']}>
                下单平台：{detailInfo?.platform}
              </div>
            </Col>
            <Col span={8}>
              <div className={styles['info-text-container']}>
                发货进度：{detailInfo?.progress}
              </div>
            </Col>
            <Col span={8}>
              <div className={styles['info-text-container']}>
                下单金额：{detailInfo?.price}
              </div>
            </Col>
          </Row>
          <Row>
            <Col span={8}>
              <div className={styles['info-text-container']}>
                退货金额：{detailInfo?.refundPrice}
              </div>
            </Col>
            <Col span={8}>
              <div className={styles['info-text-container']}>
                取消金额：{detailInfo?.cancelPrice}
              </div>
            </Col>
            <Col span={8}>
              <div className={styles['info-text-container']}>
                最终结算金额：{' '}
                {detailInfo?.orderState === '已完成'
                  ? detailInfo?.settlePrice
                  : '待订单完成后计算'}
              </div>
            </Col>
          </Row>
          <Row>
            <Col span={8}>
              <Space>
                <span>客户开票：{detailInfo?.invoicingState}</span>
                {currentProgress >= 2 ? (
                  <div>
                    {['开票中', '已开票'].includes(
                      detailInfo?.invoicingState ?? '',
                    ) && detailInfo?.orderInvoiceId ? (
                      <span className="btn-link" onClick={handleJumpInvoice}>
                        查看申请{'>>'}
                      </span>
                    ) : null}
                    {detailInfo?.invoicingState === '未开票' ? (
                      <span className="btn-link" onClick={handleJumpInvoice}>
                        前往申请{'>>'}
                      </span>
                    ) : null}
                  </div>
                ) : null}
              </Space>
            </Col>
            <Col span={8}>
              <div className={styles['info-text-container']}>
                对账完毕：{detailInfo?.returnState}
              </div>
            </Col>
            <Col span={8}>
              <div className={styles['info-text-container']}>
                回款方式：{detailInfo?.paymentMethodList?.join(',')}
              </div>
            </Col>
          </Row>
          <Row>
            <Col span={8}>
              <div className={styles['info-text-container']}>
                供应商开票：
                {
                  openInvoiceStateDictInvert?.[
                    detailInfo?.accountOpenInvoiceStatus ?? '1'
                  ]?.name
                }
              </div>
            </Col>
            <Col span={8}>
              <div className={styles['info-text-container']}>
                关联报备单：{detailInfo?.accountNo}
              </div>
            </Col>
            <Col span={8}>
              <div className={styles['info-text-container']}>
                <span>付款状态：</span>
                <Space>
                  <span>
                    {
                      paymentStatusDictInvert?.[
                        detailInfo?.paymentStatus ?? '1'
                      ]?.name
                    }
                  </span>
                  {detailInfo?.paymentStatus ===
                    paymentStatusDict['待申请'].numstr &&
                  !detailInfo?.prohibitionPaymentState &&
                  detailInfo?.settlePrice !== 0 ? (
                    <span
                      className="btn-link"
                      onClick={() =>
                        handleJumpAddPayment({
                          accountOpenInvoiceStatus:
                            accountOpenInvoiceStateDictInvert?.[
                              detailInfo?.accountOpenInvoiceStatus
                            ]?.name,
                          orderNo: detailInfo.orderNo,
                          customer: detailInfo.customer,
                          finalPrice: detailInfo?.settlePrice,
                          orderId: detailInfo.id,
                          orderPrice: detailInfo?.price,
                          orderState: detailInfo?.orderState,
                          orderTime: detailInfo?.createTime,
                          platform: detailInfo?.platform,
                          returnState: detailInfo?.returnState,
                          accountId: detailInfo?.accountId,
                          id: detailInfo.id,
                          signVoucherState:
                            detailInfo.signVoucherState as string,
                        })
                      }
                    >
                      {'前往申请>>'}
                    </span>
                  ) : null}
                  {[
                    paymentStatusDict['付款中'].numstr,
                    paymentStatusDict['付款完成'].numstr,
                  ].includes(detailInfo?.paymentStatus ?? '') ? (
                    <Link
                      to={`/srm/paymentrequestdetail?id=${detailInfo?.orderPaymentId}`}
                    >
                      {'查看详情>>'}
                    </Link>
                  ) : null}
                  {detailInfo?.paymentStatus ===
                  paymentStatusDict['不可付款'].numstr ? (
                    <Tippy
                      content={
                        <div className={styles['tooltip-card']}>
                          <Row className={styles['header']}>
                            满足以下条件可申请付款
                          </Row>
                          <Row className={styles['content']}>
                            <Space>
                              {(detailInfo?.confirmVoucherTime ?? null) !==
                              null ? (
                                <CheckOutlined
                                  style={{
                                    color: 'green',
                                  }}
                                />
                              ) : (
                                <CloseCircleOutlined
                                  style={{
                                    color: 'red',
                                  }}
                                />
                              )}
                              <span>签收凭证已确认</span>
                            </Space>
                          </Row>
                          <Row className={styles['content']}>
                            <Space>
                              {detailInfo?.returnState === '已完成' ? (
                                <CheckOutlined
                                  style={{
                                    color: 'green',
                                  }}
                                />
                              ) : (
                                <CloseCircleOutlined
                                  style={{
                                    color: 'red',
                                  }}
                                />
                              )}
                              <span>客户已回款</span>
                            </Space>
                          </Row>
                          <Row className={styles['content']}>
                            <Space>
                              {openInvoiceStateDictInvert?.[
                                detailInfo?.accountOpenInvoiceStatus ?? '1'
                              ]?.name === '已开票' ? (
                                <CheckOutlined
                                  style={{
                                    color: 'green',
                                  }}
                                />
                              ) : (
                                <CloseCircleOutlined
                                  style={{
                                    color: 'red',
                                  }}
                                />
                              )}
                              <span>供应商已开票</span>
                            </Space>
                          </Row>
                        </div>
                      }
                    >
                      <QuestionCircleOutlined />
                    </Tippy>
                  ) : null}
                </Space>
              </div>
            </Col>
          </Row>
          <Row>
            <Col span={8}>
              <div className={styles['info-text-container']}>
                客户备注：{detailInfo?.remark}
              </div>
            </Col>
            <Col span={8}>
              <div className={styles['info-text-container']}>
                签约抬头：
                {detailInfo?.titleOfTheContract ||
                  '万聚国际（杭州）供应链有限公司'}
              </div>
            </Col>
            <Col span={8}>
              <Space>
                采购合同：
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                  }}
                >
                  {detailInfo?.purchaseOrderContract ? (
                    filesRender()
                  ) : (
                    <Customupload
                      multiple={false}
                      textBtn="上传文件"
                      accept=".pdf,.gif,.png,.jpg,.jpeg,.doc,.docx"
                      uploadBtn={
                        <Button type="default" size="small">
                          上传合同
                          <UploadOutlined />
                        </Button>
                      }
                      beforeUpload={(a) => inTableUploadfile(a)}
                    />
                  )}
                  <Button
                    style={{ marginLeft: '10px' }}
                    onClick={() => downLoadTemplate()}
                  >
                    下载合同
                    <DownloadOutlined />
                  </Button>
                </div>
              </Space>
            </Col>
          </Row>
          <Row>
            <Col span={8}>
              <Space>
                客户资料：
                <div
                  style={{
                    display: 'flex',
                  }}
                >
                  {customerRender()}
                </div>
              </Space>
            </Col>
            <Col span={8}>
              <Space>
                订单备注：
                <div
                  style={{
                    display: 'flex',
                  }}
                >
                  {detailInfo?.orderRemark || '-'}
                </div>
              </Space>
            </Col>
          </Row>
        </div>
      </div>
      <div className={styles['sign-info']}>
        <div className={styles['header']}>
          <Row
            justify="space-between"
            style={{
              width: '100%',
            }}
          >
            <Space>
              <span>签收信息</span>
              <div>
                {currentProgress === 0 && (
                  <span className={styles['desp-info']}>
                    发货后可上传签收凭证
                  </span>
                )}
              </div>
              {(currentProgress === 2 || currentProgress === 1) &&
              detailInfo?.acceptAuditState === '1' ? (
                <span className={styles['desp-info']}>
                  咸亨审核中，请耐心等待
                </span>
              ) : (
                ''
              )}
              {(currentProgress === 2 || currentProgress === 1) &&
              detailInfo?.acceptAuditState === '2' ? (
                <>
                  <span className={styles['reject-info']}>
                    <span className={styles['reject-per']}>
                      驳回人：{detailInfo.acceptAuditMan}
                    </span>
                    <span>
                      驳回理由：
                      {detailInfo.acceptGroundsForRejection}
                    </span>
                  </span>
                </>
              ) : (
                ''
              )}
              {currentProgress === 3 &&
                detailInfo?.acceptAuditState === '3' && (
                  <span className={styles['success-info']}>签收凭证已确认</span>
                )}
            </Space>
            <div>
              {(currentProgress === 1 && !detailInfo?.acceptInfoDTOS.length) ||
              (currentProgress === 2 && !detailInfo?.acceptInfoDTOS.length) ||
              (detailInfo?.acceptInfoDTOS.length &&
                !detailInfo?.acceptAuditState) ||
              (detailInfo?.acceptInfoDTOS.length &&
                (detailInfo?.acceptAuditState === '2' ||
                  detailInfo?.acceptAuditState === '4')) ? (
                <Space>
                  <Button onClick={downloadCustomCertificate}>
                    下载客户定制验收单
                  </Button>
                  <Button onClick={downloadAllCertificate}>
                    下载咸亨标准验收单
                  </Button>
                  <Button onClick={showUploadCertificateModal}>上传凭证</Button>
                  <Button type="primary" onClick={saveAndSubmitCheck}>
                    保存并提交审核
                  </Button>
                </Space>
              ) : // 订单状态为待履约时支持下载咸亨标准验收单功能
              detailInfo?.orderState === '待履约' ? (
                <Space>
                  <Button onClick={downloadCustomCertificate}>
                    下载客户定制验收单
                  </Button>
                  <Button onClick={downloadAllCertificate}>
                    下载咸亨标准验收单
                  </Button>
                </Space>
              ) : null}
            </div>
          </Row>
        </div>
        <Row className={styles['content']}>
          <Col span={8}>
            <div className={styles['info-text-container']}>
              收件人：{detailInfo?.consignee}
            </div>
          </Col>
          <Col span={8}>
            <div className={styles['info-text-container']}>
              联系方式：{detailInfo?.mobile}
            </div>
          </Col>
          <Col span={8}>
            <div className={styles['info-text-container']}>
              收货地址：{detailInfo?.address}
            </div>
          </Col>
        </Row>
        <div className={styles['content']}>
          {(detailInfo?.acceptInfoDTOS?.length ?? 0) > 0 ? (
            <CustomTable
              columns={certificateColumn}
              dataSource={detailInfo?.acceptInfoDTOS}
            ></CustomTable>
          ) : null}
        </div>
      </div>
      <div className={styles['tab-container']}>
        <Spin spinning={loading}>
          <Tabs
            tabBarExtraContent={
              <Space>
                {detailInfo?.orderTransferSupported === true ? (
                  <Tooltip title="支持将订单转派给另一家供应商，转派后您将无法操作转派的物料行，请根据实际情况谨慎操作！">
                    <Button
                      type="primary"
                      className={styles['submit-button']}
                      onClick={handleOrderTransferClick}
                    >
                      订单转派
                    </Button>
                  </Tooltip>
                ) : null}

                {detailInfo?.checkState === '1' ? (
                  <Tooltip
                    title={
                      <div className={styles['tooltip-card']}>
                        <div className={styles['card-title']}>无法发货说明</div>
                        <div className={styles['card-content']}>
                          客户在平台发起了订单取消申请，平台管理员审核中，请勿发货!
                        </div>
                      </div>
                    }
                    placement="topLeft"
                  >
                    <div className={styles['info-text']}>
                      <InfoCircleFilled />
                    </div>
                  </Tooltip>
                ) : null}

                {['履约中', '待履约'].includes(
                  detailInfo?.orderState ?? 'invalid-state',
                ) ? (
                  <Button
                    type="primary"
                    className={styles['submit-button']}
                    onClick={handleDeliveryClick}
                    disabled={
                      (productList || []).filter((item: any) => {
                        return item?.isDisabled !== true
                      }).length >= 1
                        ? false
                        : true
                    }
                  >
                    发货
                  </Button>
                ) : null}
              </Space>
            }
          >
            {orderdetailTabKeyList.map((keyname) => {
              return (
                <Tabs.TabPane tab={keyname} key={keyname}>
                  {renderDetialComponents(keyname)}
                </Tabs.TabPane>
              )
            })}
          </Tabs>
        </Spin>
      </div>
      <OverdueFeedbackModal
        open={overdueFeedbackOpen}
        orderId={detailInfo?.id || ''}
        onCancel={() => setOverdueFeedbackOpen(false)}
        onSuccess={() => {
          setOverdueFeedbackOpen(false)
          refreshData()
        }}
      />
      <div
        className={styles['order-info']}
        style={{
          marginTop: '20px',
        }}
      >
        <div className={styles['header']}>
          <Space>
            <span>发票信息</span>
          </Space>
        </div>
        <div className={styles['content']}>
          <Row>
            <Col span={8}>
              <span>发票类型：</span>
              <span>{invoiceInfo?.invoiceTypeStr}</span>
            </Col>
            <Col span={8}>
              <span>开票抬头：</span>
              <span>{invoiceInfo?.invoiceTitle}</span>
            </Col>
            <Col span={8}>
              <span>纳税识别号：</span>
              <span>{invoiceInfo?.taxCode}</span>
            </Col>
          </Row>
          <Row>
            <Col span={8}>
              <span>开户行：</span>
              <span>{invoiceInfo?.bankName}</span>
            </Col>
            <Col span={8}>
              <span>银行账户：</span>
              <span>{invoiceInfo?.bankAccount}</span>
            </Col>
            <Col span={8}>
              <span>开票电话：</span>
              <span>{invoiceInfo?.openInvoiceMobile}</span>
            </Col>
          </Row>
          <Row>
            <Col span={8}>
              <span>开票地址：</span>
              <span>{invoiceInfo?.invoiceAddress}</span>
            </Col>
            <Col span={16}>
              <span>票面信息：</span>
              <span>{invoiceInfo?.invoiceFaceInfo}</span>
            </Col>
          </Row>
          <Row>
            <Col span={8}>
              <span>发票接收人：</span>
              <span>{invoiceInfo?.receiveMan}</span>
            </Col>
            <Col span={8}>
              <span>联系人电话：</span>
              <span>{invoiceInfo?.mobile}</span>
            </Col>
            <Col span={8}>
              <span>收票地址：</span>
              <span>{invoiceInfo?.receiveAddress}</span>
            </Col>
          </Row>
        </div>
      </div>
      <UploadCertificateModal
        open={uploadCertificateModalOption.visible}
        onCancel={cancelUploadCertificateModal}
        detailInfo={detailInfo as any}
        onSubmitEnd={handleSubmitEnd}
        getAddOrderAccept={getAddOrderAccept}
        currentEditItem={currentEditCertificate}
      ></UploadCertificateModal>
      <PreviewModal
        open={isPreviewModalVisible}
        fileUrl={previewFileUrl}
        onCancel={cancelPreviewModal}
        waterMarkOption={waterMarkOption}
      />
      <Modal
        title={
          <>
            订单说明
            <Tooltip
              getPopupContainer={() => document.body}
              title="任何情况您都可以提供详细说明反馈给咸亨，系统支持文本输入和文件上传。"
            >
              <QuestionCircleFilled style={{ marginLeft: '3px' }} />
            </Tooltip>
          </>
        }
        destroyOnClose={true}
        width={'1000px'}
        open={isOpenModal}
        onCancel={() => openModal(false)}
        onOk={submitRichText}
        okText="提交"
        cancelText="取消"
      >
        <BraftEditor
          ref={richTextRef}
          saveEditorContent={handleContentChange}
          dataSource={richText}
        />
        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
          <div>
            <span> 上传附件：</span>
            {orderDescriptionFiles.length < 3 && (
              <Customupload
                multiple={false}
                textBtn="上传附件"
                accept=".pdf,.gif,.png,.jpg,.jpeg,.doc,.docx"
                uploadBtn={
                  <Button type="default" size="small">
                    上传附件
                    <UploadOutlined />
                  </Button>
                }
                beforeUpload={(a) => uploadRichfile(a)}
              />
            )}

            {orderDescriptionFiles.length > 0 && descriptionFilesRender()}
          </div>

          <span>最多输入500字</span>
        </div>
      </Modal>
    </div>
  )
}
